import styled from 'styled-components';
import { Property } from 'csstype';

export const OverflowMenuOpener = styled.div<{ width: Property.Width }>`
  cursor: pointer;
  width: ${({ width }) => width};
`;
